import { Button } from '@ui-propulsion/react-components';
import { useEffect, useRef, useState } from 'react';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import styles from './stickyButton.module.scss';

export default function StickyButtton({ label, link }) {
  const [isSticky, setIsSticky] = useState(false);
  const containerRef = useRef();
  useEffect(() => {
    const stickyPosition =
      containerRef.current.offsetTop + containerRef.current.clientHeight;
    const onScroll = () => {
      if (window.pageYOffset >= stickyPosition) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={`${styles.button}  ${isSticky ? styles.sticky : ''}`}>
        <Button
          aria-label={label}
          fullWidth
          onClick={(e) => handleCTAClick(e, { link })}
          href={link}
        >
          {label}
        </Button>
      </div>
    </div>
  );
}
